import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from '../../global';
import { IPlans } from '../models';
import { proConst } from '..';

export const getPlanPrice = async () => {
  const { data } = await $apiV2.get<{ data: IPlans[] }>('/premium-price/view');

  return { plans: data?.data };
};

export const usePlanPrice = () => {
  const { data, ...args } = useQuery({
    queryKey: [proConst.queryKeys.PLAN_PRICE],
    queryFn: getPlanPrice
  });

  return { ...data, ...args };
};
